import _HttpService from './HttpService';

// eslint-disable-next-line import/prefer-default-export
export const HttpService = _HttpService;
